import React, { Component } from 'react';
import qs from "qs";
import i18n from '../i18n';
import moment from 'moment';
import ResultsView from "../views/ResultsView";
import { withError } from "cw-styleguide-react";
import { route } from '../routes';
import isEqual from 'lodash.isequal';

class ResultsController extends Component {
  componentDidMount() {
    const parameters = this.props.convertParametersToFilters(this.props.location.search);
    const page = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })?.page || 1;

    let hasFilterParameterMismatch = false;

    // Update filter state based on query parameters.
    Object.keys(parameters).forEach(key => {
      if (Array.isArray(this.props.filters[key])) {
        if (JSON.stringify(this.props.filters[key]) !== JSON.stringify(parameters[key])) {
          hasFilterParameterMismatch = true;
          this.props.setFilter(key, parameters[key]);
        }
      } else {
        if (this.props.filters[key] !== parameters[key]) {
          hasFilterParameterMismatch = true;
          this.props.setFilter(key, parameters[key]);
        }
      }
    });

    this.props.setQuery(this.props.location.search);

    if (!hasFilterParameterMismatch) {
      // Set the group size depending on the current view.
      const groupSize = this.props.view === 'MAP' ? 999 : this.props.groupSize;

      this.props.loadApprenticeships(this.props.filters, page, this.props.sort, groupSize);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // Get the queries both stored in state and in the URL.
    const queryStored = qs.parse(this.props.query, { ignoreQueryPrefix: true });
    const queryUrl = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

    // If the group size or sort order has changed then navigate to the first page of the results.
    if (prevProps.groupSize !== this.props.groupSize || prevProps.sort !== this.props.sort) {
      const { page, ...queryUrlWithoutPage } = queryUrl;

      this.props.navigate(`${route('results')}${qs.stringify(queryUrlWithoutPage, { addQueryPrefix: true, arrayFormat: 'repeat' })}`);
    }

    // If the query, view, group size or sort order have changed then reload the apprenticeships.
    if (!isEqual(queryStored, queryUrl) || prevProps.view !== this.props.view || prevProps.groupSize !== this.props.groupSize || prevProps.sort !== this.props.sort) {
      this.props.setQuery(qs.stringify(queryUrl, { addQueryPrefix: true, arrayFormat: 'repeat' }));

      // Set the group size depending on the current view.
      const groupSize = this.props.view === 'MAP' ? 999 : this.props.groupSize;

      this.props.loadApprenticeships(this.props.filters, queryUrl.page || 1, this.props.sort, groupSize);
    }
  }

  render() {
    // Create map markers.
    let markers = [];
    this.props.apprenticeships.forEach(apprenticeship => {
      if (apprenticeship.coordinates) {
        let coordinates = apprenticeship.coordinates.replace(' ', '').split(',');

        markers.push([
          apprenticeship.title,
          parseFloat(coordinates[0]),
          parseFloat(coordinates[1]),
          [apprenticeship.location, apprenticeship.employer, moment(apprenticeship.closingDate).format('DD/MM/YYYY')],
          apprenticeship.slug,
          i18n.language === 'cy' ? 'Gweld y manylion' : 'View details'
        ]);
      }
    });

    return (
      <ResultsView
        {...this.props}
        {...this.state}
        markers={markers}
      />
    );
  }
}

export default withError(ResultsController);
